<template>
  <div>
    <div class="row">
      <div v-if="activeElement.hasImage" class="col-l-6 col-m-12 offset-bottom-2 pull-right text-right">
        <img :src="`delegates/barring/content/businesspartner/${activeElement.bpNumber}`" alt="" aria-hidden="true" class="logo offset-right-1" />
        <!-- #D338 -->
      </div>
      <div :class="activeElement.hasImage ? 'col-l-6 col-m-12 pull-left' : 'col-xl-12 col-l-12 col-m-12 col-s-12'">
        <VSection>
          <template #label>
            {{ $tc('persistentconfirmations.partner_for_id', activeElement.bpNumber) }}
            <!-- #S954 + #D594 -->
          </template>
          <template #default>
            <VDescriptionList>
              <VEntry :data="partnerDetails" field="data.name" name="common.customer_view_partner_information_partner_name" />
              <VEntry :data="partnerDetails" field="data.website" name="common.customer_view_partner_information_website" />
              <VEntry :data="partnerDetails" field="data.phone" name="common.customer_view_partner_information_hotline" />
              <VEntry :data="partnerDetails" field="data.fax" name="common.customer_view_partner_information_fax" />
              <VEntry :data="partnerDetails" field="data.taxNumber" name="common.customer_view_partner_information_taxno" />
              <VEntry :data="partnerDetails" field="data.email" name="common.customer_view_partner_information_email" />
              <VEntry v-slot="{ value }" :data="partnerDetails" field="data" name="common.customer_view_partner_information_address">
                <VAddress :data="value" />
              </VEntry>
            </VDescriptionList>
          </template>
        </VSection>
      </div>
    </div>

    <VSection label="persistentconfirmations.factoring_invoice_text">
      <VDescriptionListDivided>
        <VEntry :data="partnerDetails" field="expertView.shortName" name="persistentconfirmations.factoring_short_name" />
        <VEntry :data="partnerDetails" field="expertView.shortNameTotal" name="persistentconfirmations.factoring_short_name_total" />
        <VEntry :data="partnerDetails" field="data.factoringInformation.address1" name="persistentconfirmations.factoring_address1" />
        <VEntry :data="partnerDetails" field="data.factoringInformation.address2" name="persistentconfirmations.factoring_address2" />
        <VEntry :data="partnerDetails" field="data.factoringInformation.address3" name="persistentconfirmations.factoring_address3" />
        <VEntry :data="partnerDetails" field="data.factoringInformation.address4" name="persistentconfirmations.factoring_address4" />
        <VEntry :data="partnerDetails" field="data.factoringInformation.address5" name="persistentconfirmations.factoring_address5" />
        <VEntry :data="partnerDetails" field="expertView.serviceEmailAddress" name="persistentconfirmations.factoring_serviceEmailAddress" />
        <VEntry :data="partnerDetails" field="expertView.urlTermsConditions" name="persistentconfirmations.factoring_urlTermsConditions" />
        <VEntry :data="partnerDetails" field="expertView.urlContractRetraction" name="persistentconfirmations.factoring_urlContractRetraction" />
        <VEntry :data="partnerDetails" field="expertView.urlDataStorage" name="persistentconfirmations.factoring_urlDataStorage" />
        <VEntry :data="partnerDetails" field="expertView.urlDataProtection" name="persistentconfirmations.factoring_urlDataProtection" />
        <VEntry :data="partnerDetails" field="expertView.urlFaq" name="persistentconfirmations.factoring_urlFaq" />
        <VEntry :data="partnerDetails" field="expertView.urlPartnerShop" name="persistentconfirmations.factoring_urlPartnerShop" />
        <VEntry :data="partnerDetails" field="expertView.urlServicePortal" name="persistentconfirmations.factoring_urlServicePortal" />
      </VDescriptionListDivided>
    </VSection>

    <VSection label="persistentconfirmations.details_customer_view_headline">
      <VDescriptionListDivided>
        <VEntry v-slot="{ value }" :data="activeElement" field="status" name="persistentconfirmations.details_status">
          {{ $tm('persistentconfirmations.status_', value) }}
        </VEntry>
        <VEntry :data="activeElement" field="expertView.contractNumber" name="persistentconfirmations.partnerContractNumber" />
        <VEntryDate :data="activeElement" field="nextIdealChargingDate" name="persistentconfirmations.details_nextidealchargingdate" />
        <VEntryDate :data="activeElement" field="expertView.nextChargingSlotBegin" name="persistentconfirmations.nextChargingSlotBegin" />
        <VEntryDate :data="activeElement" field="expertView.nextChargingSlotEnd" name="persistentconfirmations.nextChargingSlotEnd" />
        <VEntry :data="activeElement" field="expertView.numberOfUpdates" name="persistentconfirmations.numberOfUpdates" />
        <VEntry :data="activeElement" field="expertView.maxMissedChargingSlots" name="persistentconfirmations.maxMissedChargingSlots" />
        <VEntry v-slot="{ value }" :data="activeElement" field="expertView.missedChargingSlots" name="persistentconfirmations.missedChargingSlotList">
          <div v-for="d in value" :key="d">{{ formatDateTime(d) }}</div>
        </VEntry>
        <VEntryDate :data="activeElement" field="finalExpiryDate" name="persistentconfirmations.details_finalexpirydate" />
        <VEntryDate :data="activeElement" field="deletionDate" name="persistentconfirmations.details_deletiondate" />
      </VDescriptionListDivided>
    </VSection>

    <VSection label="persistentconfirmations.details_charging_info">
      <VDescriptionListDivided>
        <VEntry :data="activeElement" field="serviceDescription" name="persistentconfirmations.details_service_description" />
        <VEntry :data="activeElement" field="expertView.factoringContentCategory" name="persistentconfirmations.category" />
        <VEntry :data="activeElement" field="expertView.factoringContentTypeCode" name="persistentconfirmations.contentTypeCode" />
        <VEntry :data="activeElement" field="expertView.resellingVasCode" name="persistentconfirmations.vasCode" />
        <VEntry :data="activeElement" field="expertView.resellingNumberOfUnits" name="persistentconfirmations.numberOfUnits" />
        <VEntryNumber currency-field="currency" :divide="100" :data="activeElement" field="grossAmount" name="persistentconfirmations.details_service_price" />
        <VEntry v-slot="{ value }" name="persistentconfirmations.details_service_charging_cycle" :data="activeElement" field="chargingCycle">{{
          convertChargingCycle(value)
        }}</VEntry>
        <VEntryNumber :data="activeElement" field="expertView.maxApplicableDiscount" name="persistentconfirmations.maxApplicableDiscount" />
      </VDescriptionListDivided>
    </VSection>

    <VSection label="persistentconfirmations.details_creation_info">
      <VDescriptionListDivided>
        <VEntry
          v-if="
            hasRightPaymentTransactions && activeElement.creationDate && activeElement.xid && isWithinTimeFrame(activeElement.creationDate, maximumTimeFrame)
          "
          name="persistentconfirmations.details_creation_taid"
        >
          <VButton
            class="btn-default btn-small offset-bottom-1"
            :label="activeElement.xid"
            :title="$tt('persistentconfirmations.details_creation_taid')"
            :to="{
              name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
              params: {
                from: formatDateUrl(activeElement.creationDate),
                to: formatDateUrl(activeElement.creationDate),
                transactionId: activeElement.xid,
                tab: $route.params.tab,
              },
            }"
          />
        </VEntry>
        <VEntry v-else :data="activeElement" field="xid" name="persistentconfirmations.details_creation_taid" />
        <VEntryDate :data="activeElement" field="creationDate" name="persistentconfirmations.details_creation_date" />
        <VEntryDate :data="activeElement" field="expertView.importedCreationDate" name="persistentconfirmations.importedCreationDate" />
      </VDescriptionListDivided>
    </VSection>

    <VSection label="persistentconfirmations.details_reusage_info">
      <VDescriptionListDivided>
        <VEntry
          v-if="
            hasRightPaymentTransactions &&
              activeElement.lastUsageDate &&
              activeElement.reusedByTaId &&
              isWithinTimeFrame(activeElement.lastUsageDate, maximumTimeFrame)
          "
          name="persistentconfirmations.details_reusage_taid"
        >
          <VButton
            class="btn-default btn-small offset-bottom-1"
            :label="activeElement.reusedByTaId"
            :title="$tt('persistentconfirmations.details_reusage_taid')"
            :to="{
              name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
              params: {
                from: formatDateUrl(activeElement.lastUsageDate),
                to: formatDateUrl(activeElement.lastUsageDate),
                transactionId: activeElement.reusedByTaId,
                tab: $route.params.tab,
              },
            }"
          />
        </VEntry>
        <VEntry v-else :data="activeElement" field="reusedByTaId" name="persistentconfirmations.details_reusage_taid" />
        <VEntryDate :data="activeElement" field="lastUsageDate" name="persistentconfirmations.details_reusage_date" />
      </VDescriptionListDivided>
    </VSection>

    <VSection label="persistentconfirmations.billWarningHeadline">
      <VDescriptionListDivided>
        <VEntry :data="activeElement" field="expertView.billWarnEventsCounter" name="persistentconfirmations.billWarnEventsCounter" />
        <VEntryDate :data="activeElement" field="expertView.billWarnLastEvent" name="persistentconfirmations.billWarnLastEvent" />
        <VEntryDate :data="activeElement" field="expertView.billWarnLastTotalChargeUpdate" name="persistentconfirmations.billWarnLastTotalChargeUpdate" />
        <VEntry :data="activeElement" field="expertView.billWarnTotalCharge" name="persistentconfirmations.billWarnTotalCharge" />
      </VDescriptionListDivided>
    </VSection>
  </div>
</template>

<script>
import { convertChargingCycle } from '@/utils/price';
import VSection from '@/components/Section';
import VButton from '@/components/Button';
import { mapGetters } from 'vuex';
import { PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS } from '@route-types';
import { isWithinTimeFrame, formatDateUrl, formatDateTime } from '@/utils/date';

export default {
  name: 'PersistentConfirmationsDetails',

  components: {
    VSection,
    VButton,
    VDescriptionList: () => import('@/components/DescriptionList'),
    VDescriptionListDivided: () => import('@/components/DescriptionList/Divided'),
    VEntry: () => import('@/components/DescriptionList/Entry'),
    VEntryDate: () => import('@/components/DescriptionList/EntryDate'),
    VEntryNumber: () => import('@/components/DescriptionList/EntryNumber'),
    VAddress: () => import('@/components/Address'),
  },

  props: {
    partnerDetails: {
      type: Object,
      required: false,
      default: null,
    },
    activeElement: {
      type: Object,
      required: true,
    },
    maximumTimeFrame: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
    };
  },

  computed: {
    ...mapGetters('system', {
      hasRightPaymentTransactions: 'hasAccessPaymentTransactions',
    }),
  },

  methods: {
    convertChargingCycle,
    formatDateTime,
    formatDateUrl,
    isWithinTimeFrame,
  },
};
</script>
